// This file was automatically generated and should not be edited.
/* eslint-disable */

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_article_pose_anatomy: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `ANATOMY`,
    es: `ANATOMÍA`,
  };
  return phrases[locale] || phrases.en || 'article_pose_anatomy';
};
